module.exports = __webpack_public_path__ + "assets/img/designer-portfolio.ab5b5bf2.png";